import cx from 'classnames';
import parse from 'html-react-parser';
import useTranslation from 'next-translate/useTranslation';

import { addresses, phones, nif, emails } from '../../../shared';
import CountriesContacts from '../../modules/countries-contacts';
import PhoneNotice from '../../modules/help-contacts/phone-notice';
import BPartsBicon from '../../ui/icons/bparts-b-icon';

const contacts = [
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/pt.svg`,
      alt: 'countries-contacts:countries.pt.name',
    },
    title: 'countries-contacts:countries.pt.name',
    attributes: [
      {
        label: 'countries-contacts:countries.address',
        value: addresses.pt,
        variant: 'address',
      },
      {
        label: 'countries-contacts:countries.phone',
        value: phones.pt,
        variant: 'phone',
      },
    ],
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/es.svg`,
      alt: 'countries-contacts:countries.es.name',
    },
    title: 'countries-contacts:countries.es.name',
    attributes: [
      {
        label: 'countries-contacts:countries.address',
        value: addresses.es,
        variant: 'address',
      },
      {
        label: 'countries-contacts:countries.phone',
        value: phones.es,
        variant: 'phone',
      },
    ],
  },
  {
    flag: {
      src: `${process.env.PUBLIC_PREFIX}/svg/icons/flags/fr.svg`,
      alt: 'countries-contacts:countries.fr.name',
    },
    title: 'countries-contacts:countries.fr.name',
    attributes: [
      {
        label: 'countries-contacts:countries.address',
        value: addresses.fr,
        variant: 'address',
      },
      {
        label: 'countries-contacts:countries.phone',
        value: phones.fr,
        variant: 'phone',
      },
    ],
  },
];

const LegalAddresses = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className={cx('separator-bottom', 'lg:border-0', 'pb-4', 'lg:pb-5')}>
        <div className="my-6 flex items-center">
          <BPartsBicon className="h-12 w-12" />
          <h3 className="ml-4 font-bold text-lg ">
            Amanhã Global, S.A.
            <br />
            (B-PARTS)
          </h3>
        </div>
        <dl className="text-xs">
          <div className="mt-4">
            <dt>{t('countries-contacts:countries.address')}</dt>
            <dd className="text-neutral-50 text-sm">
              <address className="not-italic">{parse(addresses.pt)}</address>
            </dd>
          </div>
          <div className="mt-4">
            <dt>{t('legal:main_contact.nif')}</dt>
            <dd className="text-neutral-50 text-sm">
              <address className="not-italic">{nif}</address>
            </dd>
          </div>
        </dl>
      </div>
      <div className="container lg:mb-10 mt-4 lg:mt-5">
        <CountriesContacts contacts={contacts} />
        <PhoneNotice />
      </div>
    </>
  );
};
export default LegalAddresses;
